import React from 'react';
import './LocationInfo.css';

const LocationInfo = () => {
  return (
    <div className="location-info-wrapper">
      <h2 className="location-title">Location:</h2>
      <p className="location-description">
        Villa in Hyde Park, Cairo. Located in a prime area with easy access 
        to main roads, schools, and key destinations.
      </p>
    </div>
  );
};

export default LocationInfo;